export var WalletType;
(function(WalletType) {
    WalletType["nns"] = "nns";
    WalletType["plug"] = "plug";
    WalletType["stoic"] = "stoic";
    WalletType["me"] = "me";
    WalletType["unknown"] = "unknown";
})(WalletType || (WalletType = {}));
